import React, { Fragment } from 'react'
import { Jumbotron, Container, Col, Row } from 'reactstrap';

const Footer = props => {
    return (
        <Fragment>
            <br />
            <br />
            <div className="footer">
                <a href='https://qworky.tech' target='blank' className='footer-link'>Powered by Qworky</a>
            </div>
        </Fragment>
    )
}

export default Footer